import $i18n from 'panda-i18n';
/**
 * 搜索中状态时渲染
 */
import React from 'react';
export default (function () {
    return (React.createElement("div", { className: "cn-address--search-loading-container cn-address-search-text" }, $i18n.get({ id: 'SearchIn', dm: '搜索中...', ns: 'CnAddress' })));
});
